


















































import gql from 'graphql-tag'
import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppDialogModal from '@/components/AppDialogModal.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'

import { CURRENT_USER } from '@/gql/auth'
import { SHOW_LOGIN_MODAL } from '@/gql/misc'
import { Common } from '@/mixins'

@Component({
  components: {
    AppDialogModal,
    AppRouterLink
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    feedComments: {
      query: gql`query feedComments($feedId: Int!) {
        feedComments(feedId: $feedId) {
          id
          text
          likeCount
          createdAt
          parentCommentId
          liked
          feed {
            id
            user {
              id
            }
          }
          user {
            id
            displayName
            username
            media {
              id
              path
            }
          }
        }
      }`,
      variables () {
        return {
          feedId: +this.feedId
        }
      }
    }
  }
})
export default class extends Mixins(Common) {
  @Prop(String) readonly feedId!: string
  @Prop(Object) readonly myUser!: object
  currentUser = null
  feedComments = []
  text = ''
  parentComment: { id: string; user: { username: string } } | null = null

  get placeholderText () {
    if (this.parentComment) {
      return `@${this.parentComment.user.username}님께 댓글 남기기`
    }
    return '댓글을 남겨주세요.'
  }

  isChildComment (comment: { parentCommentId: string }) {
    return comment.parentCommentId !== '-1'
  }

  async reset (comment: { id: string; user: { username: string } } | null = null) {
    const el = document.getElementById('comments-modal__input') as HTMLInputElement

    if (!this.currentUser) {
      el.blur()
      await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
      return
    }

    this.parentComment = comment

    if (document.activeElement !== el) {
      this.text = ''
      el.focus()
    }
  }

  async createComment () {
    if (!this.text) return

    const { data } = await this.$apollo.mutate({
      mutation: gql`mutation createComment($input: CreateCommentInput!) {
        createComment(input: $input) {
          message
          comment {
            id
            feed {
              id
              commentCount
            }
          }
        }
      }`,
      variables: {
        input: {
          feedId: this.feedId,
          parentCommentId: this.parentComment && this.parentComment.id,
          text: this.text
        }
      }
    })

    this.reset()
    this.text = ''
    await this.$apollo.queries.feedComments.refetch()
    await this.showToast(data.createComment.message)
  }

  async deleteComment (commentId: string) {
    const result = confirm('댓글을 삭제하시겠습니까?')
    if (!result) return

    const { data } = await this.$apollo.mutate({
      mutation: gql`mutation deleteComment($input: DeleteCommentInput!) {
        deleteComment(input: $input) {
          message
          feed {
            id
            commentCount
          }
        }
      }`,
      variables: {
        input: {
          commentId
        }
      }
    })

    await this.$apollo.queries.feedComments.refetch()
    await this.showToast(data.deleteComment.message)
  }

  async onClickLike (comment: { id: string; liked: boolean }) {
    if (!this.currentUser) {
      await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
      return
    }

    const { data } = await this.$apollo.mutate({
      mutation: gql`mutation likeComment($input: LikeCommentInput!) {
        likeComment(input: $input) {
          message
          comment {
            id
            likeCount
            liked
          }
        }
      }`,
      variables: {
        input: {
          commentId: comment.id,
          isLike: !comment.liked
        }
      }
    })
    await this.showToast(data.likeComment.message)
  }
}
